import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { CollapsibleSection } from "@sportal/cdk/collapsibleSection";

import { CollapsibleSectionHeader } from "../collapsibleSectionHeader/CollapsibleSectionHeader";
import { WebFiltersProtectionToolbar } from "./WebFiltersProtectionToolbar";
import { ProtectionEditor } from "./protectionEditor/ProtectionEditor";
import { allow, block } from "./webFilters.actions";
import { useWebFilterCategories } from "./hooks";

export interface WebFiltersComponentDesktopProps {
  profileId: string;
}

export const WebFiltersComponentDesktop = ({
  profileId,
}: WebFiltersComponentDesktopProps) => {
  const dispatch = useDispatch();
  const categories = useWebFilterCategories(profileId);

  const allowCategories = (categoriesNames) =>
    dispatch(allow(categoriesNames, profileId));
  const blockCategories = (categoriesNames) =>
    dispatch(block(categoriesNames, profileId));

  return (
    <CollapsibleSection
      defaultOpened
      header={
        <CollapsibleSectionHeader
          clickableHeader={
            <h3>
              <FormattedMessage id={"protection_level"} />
            </h3>
          }
          description={<FormattedMessage id={"protection_level_subtitle"} />}
        />
      }
      content={
        <ProtectionEditor
          header={<WebFiltersProtectionToolbar profileId={profileId} />}
          profileId={profileId}
          categories={categories}
          onAllow={allowCategories}
          onBlock={blockCategories}
        />
      }
    />
  );
};
